import React, { useContext } from "react";
import TableRowO from "./TableRow";
import ListadoContext from "../../../../context/ListadoContext";
import { parseSelectedData } from "../../../ListadoFunciones";

function StateWrapper({ data, cabeceras, listadoSeleccion }) {
  const {
    dataStore: rowStore,
    dispatch,
    opciones,
  } = useContext(ListadoContext);

  const rowState = rowStore((state) => state.rowStates[data._key] || {});
  // const initRowState = rowStore((state) => state.initRowState);
  const updateRowState = rowStore((state) => state.updateRowState);
  const check = rowStore((state) => state.checkRow);

  // useEffect(() => {
  //   initRowState(data._key, data);
  // }, [data, initRowState]);

  const updateState = (key, value) => {
    const rowState = updateRowState(data._key, { [key]: value });
    if(opciones.listado_seleccion === 's'){
      const datosParseados = parseSelectedData(cabeceras, rowState, opciones);
      dispatch({ type: "UPDATE_DATO_SELECCIONADO", payload: datosParseados });
    }
  };

  const onCheck = (e) => {
    const rowState = check(data._key);
    const datosParseados = parseSelectedData(cabeceras, rowState, opciones);
    dispatch({ type: "SET_DATO_SELECCIONADO", payload: datosParseados });
  };

  return (
    <TableRowO
      rowState={rowState}
      updateState={updateState}
      data={data}
      cabeceras={cabeceras}
      listadoSeleccion={listadoSeleccion}
      onCheck={onCheck}
    />
  );
}

export default StateWrapper;
